module.exports = __webpack_public_path__ + "img/stripe.7d69ded9.svg";